/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Checks if the current environment is running on a Cloudflare Pages preview deployment.
 * Supports both funcirclegames.pages.dev and fmg-beta.pages.dev preview deployments.
 * Example of preview URL: https://abc123xyz.funcirclegames.pages.dev
 */
export const isPagesPreview = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return (
    (hostname.endsWith('.funcirclegames.pages.dev') && hostname !== 'funcirclegames.pages.dev') ||
    (hostname.endsWith('.fmg-beta.pages.dev') && hostname !== 'fmg-beta.pages.dev')
  );
};

/**
 * Checks if the current environment is any Pages deployment (either production or preview)
 * for both funcirclegames.pages.dev and fmg-beta.pages.dev.
 */
export const isPagesDeployment = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return (
    hostname === 'funcirclegames.pages.dev' ||
    hostname.endsWith('.funcirclegames.pages.dev') ||
    hostname === 'fmg-beta.pages.dev' ||
    hostname.endsWith('.fmg-beta.pages.dev')
  );
};

/**
 * Utility to dynamic-resolve API, Authentication or CDN urls based on current environment.
 * Prefers explicitly defined environment variables, falling back to clean relative routes.
 */
export const getEnvVariable = (key: 'VITE_API_URL' | 'VITE_AUTH_URL' | 'VITE_CDN_URL'): string => {
  const envValue = import.meta.env[key];
  if (envValue) {
    return envValue;
  }
  
  // Logical Fallbacks in case environment variables are missing
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    if (key === 'VITE_API_URL') {
      return `${origin}/api`;
    }
    if (key === 'VITE_AUTH_URL') {
      return origin;
    }
  }
  return '';
};
